import { Box, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import AutoDeleteTwoToneIcon from '@mui/icons-material/AutoDeleteTwoTone';
import React, { useContext, useEffect, useState } from 'react';
import SubscriptionDB from '../services/db/subscription';
import { InfoContext } from '../services/Context/Info/context';
import AddSubscription from './elements/AddSubscription';
import { DataGrid } from '@mui/x-data-grid';
import search from '../utils/searchEngine';

const columns = [
    {
        headerName: 'Subscriptions',
        field: 'subscription',
        width: 250
    },
    {
        headerName: 'Cost',
        field: 'amount',
        width: 250,
        renderCell: ({ row }) => `RS ${row.amount}`
    },
    {
        headerName: 'Action',
        field: 'action',
        width: 250,
        renderCell: ({ row }) => (
            <>
                <AddSubscription data={row} />
                <IconButton
                    onClick={row.handleDelete}
                    color='error'
                >
                    <AutoDeleteTwoToneIcon />
                </IconButton>
            </>
        )
    },
]

const Subscription = () => {
    const [searchQuery, setsearchQuery] = useState();
    const { data: { subscriptionData = [] }, setData } = useContext(InfoContext);
    useEffect(() => {
        if (!subscriptionData.length) new SubscriptionDB().allSubscriptions().then(r => {
            if (r?.length) setData(p => ({ ...p, subscriptionData: r }))
        })
    }, []);
    const getRowSpacing = React.useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);

    const handleDelete = (id) => {
        new SubscriptionDB().deleteSubscription(id)
            .then(() => {
                alert("Successfully Deleted Banner")
                setData(pr => ({
                    ...pr,
                    subscriptionData: subscriptionData.filter(e => e.id !== id)
                }))
            })
            .catch(() => alert("Something Went wrong"))
    }
    const subData = subscriptionData.map(el => ({ ...el, handleDelete: () => handleDelete(el.id) }))
    const searchData = search(searchQuery, subData, ['category'])
    return (
        <Box>
            <Grid xs={12} container direction='column' paddingTop={2} paddingLeft={4}>
                <Grid xs={12} paddingY={1}>
                    <Typography variant='subtitle1'>Subsciption</Typography>
                </Grid>
                <Grid container direction='row' justifyContent='space-between'>
                    <TextField
                        placeholder="Search"
                        size='small'
                        sx={{ bgcolor: '#faf0e6', border: 'none' }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        onChange={e => setsearchQuery(e.currentTarget.value)}
                    />
                    <AddSubscription />
                </Grid>
                <Grid paddingTop={2}>
                    <DataGrid
                        className='datagrid'
                        rows={searchData}
                        columns={columns}
                        getRowClassName={() => 'row'}
                        showCellVerticalBorder={false}
                        // getRowId={(row)=>`${row.phoneNumber}_${row.role}`}
                        // ref={pdfRef}
                        hideFooterPagination={true}
                        getRowSpacing={getRowSpacing}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default Subscription